import { useHistory, useLocation } from 'react-router';
import { isConversationUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';
import useBrokerId from '../../../../common/src/hooks/query-params/useBrokerId';
import usePartyId from '../../../../common/src/hooks/query-params/usePartyId';
import useQueryParams from '../../../../common/src/hooks/useQueryParams';
import { FlowFunctionParams } from './useFlowsInitNew';

interface UseFlowsInitRoutes {
  pushFlowsRoute: (params: PushFlowsRouteParams) => void;
  pushUserToFlow: (params: FlowFunctionParams) => void;
  pushUserToViewOnly: (params: FlowFunctionParams) => void;
}

interface PushFlowsRouteParams {
  flowId: string;
  sessionId: string;
  partyId?: string;
  brokerId?: string;
  position?: number;
  replace?: boolean;
}

/**
 * Contians functions for changing the routing related to flows
 */
const useFlowsInitRoutes = (): UseFlowsInitRoutes => {
  const history = useHistory();
  const qPartyId = usePartyId();
  const qBrokerId = useBrokerId();
  const qLang = useQueryParams().get('lang');
  const { pathname } = useLocation();

  const pushFlowsRoute = ({
    flowId,
    sessionId,
    partyId,
    brokerId,
    position = 0,
  }: PushFlowsRouteParams) => {
    const route = `/flows/${flowId}/questions/${sessionId}/${position}${
      isConversationUrl
        ? `?party_id=${partyId}&broker_id=${brokerId}&lang=${qLang}`
        : ''
    }`;

    history.replace(route);
  };

  const pushUserToFlow = ({ flow, initParams }: FlowFunctionParams) => {
    const partyId = qPartyId || initParams.payload.party_id;

    pushFlowsRoute({
      flowId: initParams.flowId,
      sessionId: flow.session_id,
      partyId: partyId,
      brokerId: qBrokerId,
    });
  };

  const pushUserToViewOnly = ({ flow, initParams }: FlowFunctionParams) => {
    const partyId = qPartyId || initParams.payload.party_id;

    history.push(
      `/flows/${initParams.flowId}/questions/${flow.session_id}/0?backRef=${pathname}&party_id=${partyId}`,
    );
  };

  return {
    pushFlowsRoute,
    pushUserToFlow,
    pushUserToViewOnly,
  };
};

export default useFlowsInitRoutes;
